import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accounting-pattern--accounting-pattern"
export default class extends Controller {
  static targets = ["helperRow"]

  connect() {
    this.helperRowTargets.forEach((row) => {
      this.updateRowState(row)
    })
  }

  toggleMode(event) {
    const row = event.target.closest("[data-accounting-pattern--accounting-pattern-target='helperRow']")
    if (row) this.updateRowState(row)
  }

  updateRowState(row) {
    const select = row.querySelector("select")
    const codeInput = row.querySelector("input[name*='[code]']")
    const nameInput = row.querySelector("input[name*='[name]']")
    
    if (!select || !codeInput || !nameInput) return

    const mode = select.value

    if (mode === "manual") {
      row.classList.add("code-mode")
      codeInput.disabled = false
      codeInput.readOnly = false
      nameInput.disabled = false
      nameInput.readOnly = false
      
      if (codeInput.value === "実績の事業" || codeInput.value === "実績の作業班") {
        codeInput.value = ""
      }
      if (nameInput.value === "実績の事業" || nameInput.value === "実績の作業班") {
        nameInput.value = ""
      }
    } else {
      // For target: project, owner, union, team
      row.classList.remove("code-mode")
      codeInput.disabled = true
      codeInput.readOnly = true
      nameInput.disabled = true
      nameInput.readOnly = true

      codeInput.value = ""
      nameInput.value = ""
    }
  }
}
